import { post } from '@/common/request';

/**
 * @description 商业直租周边报告PDF - 获取周边分析报告
 * https://yapi.lanhanba.com/project/560/interface/api/65631
 */
export function getEnvironmentReport(params: any, token: any) {
  return post('/brand/environmental/report', { ...params }, { needCancel: false, proxyApi: '/zhizu-api', headers: {
    token,
    clientKey: 1001213,
  } });
}


/**
 * @description 商业直租周边报告PDF - 历史各业态门店存活率分布
 * https://yapi.lanhanba.com/project/560/interface/api/67843
 */
export function getStoreSuviveRate(params: any, token: any) {
  return post('/brand/environmental/storeSurvivalRate', { ...params }, { needCancel: false, proxyApi: '/zhizu-api', headers: {
    token,
    clientKey: 1001213,
  } });
}

/**
 * @description 商业直租周边报告PDF - 获取门店经营报告
 * https://yapi.lanhanba.com/project/560/interface/api/67850
 */
export function getStoreOperation(params: any, token: any) {
  return post('/brand/environmental/storeOperation', { ...params }, { needCancel: false, proxyApi: '/zhizu-api', headers: {
    token,
    clientKey: 1001213,
  } });
}

/**
 * @description 商业直租周边报告PDF - 获取小程序二维码
 * https://yapi.lanhanba.com/project/560/interface/api/67850
 */
export function getLocationCode(params: any, token: any) {
  return post('/brand/environmental/reportAppCode', { ...params }, { needCancel: false, proxyApi: '/zhizu-api', headers: {
    token,
    clientKey: 1001213,
  } });
}

/**
 * @description 商业直租周边报告PDF - 获取专属报告内容
 * https://yapi.lanhanba.com/project/560/interface/api/69467
 */
export function getExclusiveRecord(params: any, token: any) {
  return post('/brand/environmental/exclusiveAnalysisRecord', { ...params }, { needCancel: false, proxyApi: '/zhizu-api', headers: {
    token,
    clientKey: 1001213,
  } });
}

/**
 * @description 商业直租周边报告PDF - 获取专属报告内容
 * https://yapi.lanhanba.com/project/560/interface/api/69467
 */
export function getEnvironmentAnalysis(params: any, token: any) {
  return post('/brand/environmental/analysis', { ...params }, { needCancel: false, proxyApi: '/zhizu-api', headers: {
    token,
    clientKey: 1001213,
  } });
}
